import { dapvApi } from 'services/providers/dapv';
import { ApiResponse } from 'services/providers/dapv.types';
import { DataLists, SpecificDataList } from './data.types';
import {
    CreateSpecificDataPayload,
    CreateSpecificDataResponse,
    DeleteSpecificDataPayload,
    SpecificDataPayload,
    UpdateSpecificDataPayload,
    UpdateSpecificDataResponse
} from './data.types';

const dataApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getAllDatas: build.mutation<ApiResponse<DataLists>, undefined>({
            query: () => {
                return {
                    url: '/core/data',
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<DataLists>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getSpecificData: build.mutation<ApiResponse<SpecificDataList<SpecificDataPayload['listName']>>, SpecificDataPayload>({
            query: ({ listName }: SpecificDataPayload) => ({
                url: `/core/data/${listName}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<SpecificDataList<SpecificDataPayload['listName']>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateSpecificData: build.mutation<ApiResponse<UpdateSpecificDataResponse>, UpdateSpecificDataPayload>({
            query: ({ id, value }: UpdateSpecificDataPayload) => ({
                url: `/core/data/${id}`,
                method: 'PUT',
                body: {
                    value
                }
            }),
            transformResponse: (response: ApiResponse<UpdateSpecificDataResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deleteSpecificData: build.mutation<ApiResponse<void>, DeleteSpecificDataPayload>({
            query: ({ id }: DeleteSpecificDataPayload) => ({
                url: `/core/data/${id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: ApiResponse<void>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createSpecificData: build.mutation<ApiResponse<CreateSpecificDataResponse>, CreateSpecificDataPayload>({
            query: (body: CreateSpecificDataPayload) => ({
                url: `/core/data`,
                method: 'POST',
                body
            }),
            transformResponse: (response: ApiResponse<CreateSpecificDataResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetAllDatasMutation,
    useCreateSpecificDataMutation,
    useDeleteSpecificDataMutation,
    useGetSpecificDataMutation,
    useUpdateSpecificDataMutation
} = dataApi;
